import { CurrentUser } from "../../../../../auth";
import { CUSTOMER_ROLES } from "../../../../../auth/model";

export class WorkAdjustmentCaseAuthorizer {
    public static isHrManager = (user: CurrentUser) => {
        const roles = user.roles;
        const hasHrRole = roles?.includes(CUSTOMER_ROLES.hr.name);
        return hasHrRole;
    };
}
